import React from 'react';
import Icon from '../../../components/AppIcon';

const navItems = [
  { id: 'dashboard', label: 'Dashboard', icon: 'LayoutDashboard' },
  { id: 'users', label: 'Users', icon: 'Users', badgeKey: 'users' },
  { id: 'brands', label: 'Brands', icon: 'Building2' },
  { id: 'campaigns', label: 'Campaigns', icon: 'Megaphone' },
  { id: 'moderation', label: 'Moderation Queue', icon: 'ShieldCheck', badgeKey: 'moderation' },
  { id: 'card-applications', label: 'Card Applications', icon: 'CreditCard', badgeKey: 'cardApplications' },
  { id: 'rewards', label: 'Rewards Ledger', icon: 'Wallet', badgeKey: 'rewards' },
  { id: 'analytics', label: 'Analytics', icon: 'BarChart3' },
  { id: 'notifications', label: 'Notifications', icon: 'Bell' },
  { id: 'settings', label: 'Settings', icon: 'Settings' },
  { id: 'audit', label: 'Audit Logs', icon: 'FileSearch', badgeKey: 'audit' },
];

const AdminSidebar = ({ activeSection, onNavigate, onLogout, displayName, isOpen, onClose, badges }) => {
  return (
    <aside
      className={`fixed top-0 left-0 h-full w-64 bg-card border-r border-border z-[100] flex flex-col transition-transform duration-300 ${
        isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
      }`}
    >
      {/* Logo */}
      <div className="h-16 flex items-center justify-between px-5 border-b border-border flex-shrink-0">
        <div className="flex items-center gap-3">
          <img
            src="/assets/images/image-1772733559968.png"
            alt="SocialCents logo"
            className="h-8 w-auto object-contain"
          />
        </div>
        <button
          onClick={onClose}
          className="lg:hidden w-8 h-8 flex items-center justify-center rounded-lg hover:bg-muted text-muted-foreground transition-colors"
          aria-label="Close sidebar"
        >
          <Icon name="X" size={16} />
        </button>
      </div>
      {/* Admin badge */}
      <div className="px-4 py-3 border-b border-border flex-shrink-0">
        <div className="flex items-center gap-2 px-3 py-2 bg-primary/10 rounded-lg">
          <div className="w-7 h-7 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0">
            <Icon name="Shield" size={13} color="var(--color-primary)" />
          </div>
          <div className="min-w-0">
            <p className="text-xs font-semibold text-primary truncate">{displayName}</p>
            <p className="text-[10px] text-primary/70">Super Admin</p>
          </div>
        </div>
      </div>
      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-3 px-3">
        <p className="text-[10px] font-semibold text-muted-foreground uppercase tracking-widest px-3 mb-2">Navigation</p>
        <ul className="space-y-0.5">
          {navItems?.map((item) => {
            const badgeCount = item?.badgeKey ? (badges?.[item?.badgeKey] || 0) : 0;
            return (
              <li key={item?.id}>
                <button
                  onClick={() => onNavigate(item?.id)}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 group ${
                    activeSection === item?.id
                      ? 'bg-primary/15 text-primary' :'text-muted-foreground hover:text-foreground hover:bg-muted'
                  }`}
                >
                  <Icon
                    name={item?.icon}
                    size={17}
                    color={activeSection === item?.id ? 'var(--color-primary)' : undefined}
                    className={activeSection !== item?.id ? 'group-hover:text-foreground' : ''}
                  />
                  <span className="flex-1 text-left">{item?.label}</span>
                  {badgeCount > 0 && (
                    <span className="ml-auto min-w-[20px] h-5 px-1.5 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center leading-none">
                      {badgeCount > 99 ? '99+' : badgeCount}
                    </span>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
      {/* Logout */}
      <div className="p-3 border-t border-border flex-shrink-0">
        <button
          onClick={onLogout}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-muted-foreground hover:text-error hover:bg-error/10 transition-all duration-200"
        >
          <Icon name="LogOut" size={17} />
          <span>Sign Out</span>
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
